<template>
    <el-dialog title="Restablecer Sistema de Puntos"
        top="20vh"
        width="40%"
        :visible="showDialog"
        @close="close"
    >
        <span>Confirmar eliminación de puntos en todos los clientes</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">
                Cancelar
            </el-button>
            <el-button type="primary"
                :loading="loading"
                @click="submit"
            >
                Confirmar
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: ['showDialog'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close() {
                this.$emit('update:showDialog', false)
            },

            async submit() {
                try {
                    this.loading = true
                    const { data } = await this.$http.get(`/configurations/reset-points`)
                    if (data.success) {
                        this.$message.success(data.message)
                        this.close()
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    this.loading = false
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/configurations/partials/reset_points_system.vue